import api from '../api'

export default {

  createGetData: async ()=> {
    return api.get('api/quotations/create')
  },

  create: async order => {
    return api.post('api/quotations', order)
  },

  repQuotations: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/quotations/rep-quotations?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },
  
  enquiry: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/quotations/enquiry?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  pdf: async (id) => {
    return api.get(`api/quotations/${id}/pdf`,{
        headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType : 'blob'
      })
  },


  createPricelist: async (data) => {
    return api.get(`api/quotations/pricelist?data=${data}`,{
      headers : { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType : 'blob'
    })
  },

  createGetDataPricelist: async (customerId)=> {
    return api.get('api/quotations/pricelist/create/'+customerId)
  },

 

}
